module.exports = __webpack_public_path__ + "img/3(3)-180x179-1.33fd774e.png";